<mat-toolbar class="main-toolbar">
  <h1 class="toolbar-title">{{ toolbarTitle$ | async }}</h1>
  <button
    *ngIf="prid$ | async as prid"
    class="account-button"
    mat-icon-button
    aria-label="Account profile"
  >
    <img
      class="account-avatar"
      [src]="getProfileImageUrl(prid)"
      alt="Profile"
    />
  </button>
</mat-toolbar>
